import Login from './Login';
import Register from './Register';
import PasswordReset from './PasswordReset';
import PasswordResetEmailRequest from './PasswordResetEmailRequest';
import Landing from './Landing';
import { logoutUser } from 'auth/store/actions';
import store from 'store';

export const AuthConfig = {
    settings: {
        layout: {
            config: {
                navbar : {
                    display: false
                },
                toolbar: {
                    display: false
                },
                footer : {
                    display: false
                }
            }
        }
    },
    routes  : [
        {
            path     : '/login',
            component: Login,
        },
        {
            path     : '/register',
            component: Register,
        },
        {
            path     : '/logout',
            component: () => {
                store.dispatch(logoutUser());
                return 'Logging out...';
            },
        },
        {
            path     : '/landing',
            component: Landing,
            // permission: { component_name: 'auth', permission_type: 'read' },
        },
        {
            path     : '/password-reset/:token',
            component: PasswordReset,
        },
        {
            path     : '/password-reset-email-request',
            component: PasswordResetEmailRequest,
        },
    ]
};



// WEBPACK FOOTER //
// src/main/content/auth/AuthConfig.js